export enum NewClientModalTabs {
    CUSTOMER = 'Customer',
    CONTACT = 'Contact',
    ADDITIONAL = 'Additional info',
    DISCOUNTS = 'Discounts',
}
